<template>
  <div class="account-page">
    <div class="account-page__header">
      <div class="account-page__header-content">
        <h1 class="account-page__title">Account Settings</h1>
        <p class="account-page__subtitle">Manage your profile, security, and preferences</p>
      </div>
    </div>
    
    <div class="account-page__container">
      <div class="account-page__layout">
        <AccountSideNav />
        <div class="account-page__content">
          <router-view v-slot="{ Component }">
            <transition name="fade-transform" mode="out-in">
              <component :is="Component" class="account-page__main" />
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import { truncate } from "@/utils/helpers.js";
  import AccountSideNav from "@/components/account/AccountSideNav";

  export default {
    name: "Account",

    components: {
      AccountSideNav,
    },

    created() {
      this.getOrgInfo();
    },

    mounted() {
      if (Object.keys(this.$route.query).length !== 0) {
        if (this.$route.query.status) {
          this.layout = "Subscription Plans";
          this.$router.push({ name: "Account" });
          switch (this.$route.query.status) {
            case "successful":
              this.showToast({
                description: "Your Payment was successful.",
                display: true,
                type: "success",
              });
              break;
            case "completed":
              this.showToast({
                description: "Your Payment was successful.",
                display: true,
                type: "success",
              });
              break;
            default:
              this.loadError();
              break;
          }
        }
      }
    },

    methods: {
      ...mapActions("organisationModule", ["getOrganisationProfile"]),
      ...mapActions(["showToast"]),

      truncate,
      async getOrgInfo() {
        try {
          await this.getOrganisationProfile();
        } catch (error) {
          return error;
        }
      },
      loadError() {
        this.showToast({
          description: "Your Payment attempt failed.",
          display: true,
          type: "error",
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .account-page {
    min-height: 100vh;
    background: #F8FAFC;

    &__header {
      background: white;
      border-bottom: 1px solid #E2E8F0;
      padding: 24px 24px;

      @media (min-width: 768px) {
        padding: 32px 40px;
      }
    }

    &__header-content {
      max-width: 1280px;
      margin: 0 auto;
    }

    &__title {
      font-family: 'DM Sans', sans-serif;
      font-size: 24px;
      font-weight: 500;
      color: #0F172A;
      margin: 0 0 4px 0;

      @media (min-width: 768px) {
        font-size: 28px;
      }
    }

    &__subtitle {
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #64748B;
      margin: 0;
    }

    &__container {
      max-width: 1280px;
      margin: 0 auto;
      padding: 24px 16px;

      @media (min-width: 768px) {
        padding: 32px 40px;
      }
    }

    &__layout {
      display: flex;
      flex-direction: column;
      gap: 24px;

      @media (min-width: 768px) {
        flex-direction: row;
        gap: 32px;
      }
    }

    &__content {
      flex: 1;
      min-width: 0;
    }

    &__main {
      background: white;
      border-radius: 12px;
      border: 1px solid #E2E8F0;
    }
  }

  .fade-transform-enter-active,
  .fade-transform-leave-active {
    transition: all 0.2s ease;
  }

  .fade-transform-enter-from {
    opacity: 0;
    transform: translateX(10px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
</style>
